/**
 * nomeMaterial — nome de exibição de uma chapa no formato "Absoluto 15 mm".
 *
 * A migração do legado (2026-09-10) montou o nome como
 * "descrição + cor + espessura", mas a descrição já trazia a cor e a
 * espessura: ficou "Absoluto 15 mm Absoluto 15.00mm". Já a planilha de
 * compras cadastra "MDF BRANCO TX 2750X1850X18MM". Medidas e espessura
 * valem pelas colunas (estoque/atributos.py), então o nome sai sem
 * dimensão e sem "NNmm", e a espessura entra uma vez só, no fim.
 */

const DIMENSOES_NO_TEXTO = /\b\d{2,5}\s*x\s*\d{2,5}(?:\s*x\s*\d+(?:[.,]\d+)?)?\s*(?:mm)?\b/gi;
const ESPESSURA_NO_TEXTO = /\b\d+(?:[.,]\d+)?\s*mm\b/gi;
const PRIMEIRA_ESPESSURA = /(\d+(?:[.,]\d+)?)\s*mm\b/i;
const SEPARADOR_SOLTO = /^[\s\-–—/,:]+|[\s\-–—/,:]+$/g;

/** "15.00" -> "15"; "0.45" -> "0,45"; vazio -> "". */
export function formatarEspessura(espessura) {
  if (espessura === null || espessura === undefined || espessura === "") return "";
  const n = Number(String(espessura).replace(",", "."));
  if (!Number.isFinite(n) || n <= 0) return "";
  return String(n).replace(".", ",");
}

function semRepeticao(palavras) {
  // "Absoluto Absoluto" -> "Absoluto"; "Bali TX Bali TX" -> "Bali TX".
  const saida = [];
  for (const palavra of palavras) {
    const chave = palavra.toLowerCase();
    const jaTem = saida.some((p) => p.toLowerCase() === chave);
    if (!jaTem) saida.push(palavra);
  }
  return saida;
}

export function nomeMaterial(produto) {
  if (!produto) return "";
  const original = String(produto.nome || "");
  // A espessura embutida na dimensão ("...X18MM") vale como reserva antes de sumir.
  const noTexto = original.match(PRIMEIRA_ESPESSURA);
  const base = original.replace(DIMENSOES_NO_TEXTO, " ").replace(ESPESSURA_NO_TEXTO, " ");
  const palavras = semRepeticao(base.split(/\s+/).filter(Boolean));
  // "ESPELHO BRONZE - 626 x 380" perde a medida e não pode sobrar "ESPELHO BRONZE -".
  const nome = palavras.join(" ").replace(SEPARADOR_SOLTO, "").trim() || original.trim();
  const espessura = formatarEspessura(produto.espessura_mm) || formatarEspessura(noTexto ? noTexto[1] : "");
  return espessura ? `${nome} ${espessura} mm` : nome;
}

/** Versão para linhas de sobra, que carregam `produto_nome` e `espessura_mm`. */
export function nomeMaterialDaSobra(sobra) {
  if (!sobra) return "";
  return nomeMaterial({ nome: sobra.produto_nome, espessura_mm: sobra.espessura_mm });
}
